export const SHOW_CONNECTOR_MODAL = 'connector-screen/SHOW_CONNECTOR_MODAL';
export const HIDE_CONNECTOR_MODAL = 'connector-screen/HIDE_CONNECTOR_MODAL';
export const TOGGLE_CONNECTOR_MODAL = 'connector-screen/TOGGLE_CONNECTOR_MODAL';

export const TOGGLE_CONNECTOR_DATA = 'connector-screen/TOGGLE_CONNECTOR_DATA';
export const GET_CONNECTOR_DATA = 'connector-screen/GET_CONNECTOR_DATA';
export const GET_SALESFORCE_NEW_CONNECTOR_DATA = 'connector-screen/GET_SALESFORCE_NEW_CONNECTOR_DATA';
export const GET_DYNAMO_NEW_CONNECTOR_DATA = 'connector-screen/GET_DYNAMO_CONNECTOR_DATA';
export const ADD_NEW_CONNECTOR = 'connector-screen/ADD_NEW_CONNECTOR';
export const ADD_NEW_SALESFORCE_CONNECTOR = 'connector-screen/ADD_NEW_SALESFORCE_CONNECTOR';
export const ADD_NEW_DYNAMO_CONNECTOR = 'connector-screen/ADD_NEW_DYNAMO_CONNECTOR';
export const UPDATE_CONNECTOR = 'connector-screen/UPDATE_CONNECTOR';
export const DELETE_CONNECTOR = 'connector-screen/DELETE_CONNECTOR';
export const DELETE_SALESFORCE_CONNECTOR = 'connector-screen/DELETE_SALESFORCE_CONNECTOR';
export const DELETE_DYNAMO_CONNECTOR = 'connector-screen/DELETE_DYNAMO_CONNECTOR';

export const SHOW_ENDPOINT_MODAL = 'connector-screen/SHOW_ENDPOINT_MODAL';
export const HIDE_ENDPOINT_MODAL = 'connector-screen/HIDE_ENDPOINT_MODAL';
export const TOGGLE_ENDPOINT_MODAL = 'connector-screen/TOGGLE_ENDPOINT_MODAL';

export const TOGGLE_ENDPOINT_DATA = 'connector-screen/TOGGLE_ENDPOINT_DATA';
export const ADD_NEW_ENDPOINT = 'connector-screen/ADD_NEW_ENDPOINT';
export const UPDATE_ENDPOINT = 'connector-screen/UPDATE_ENDPOINT';
export const DELETE_ENDPOINT = 'connector-screen/DELETE_ENDPOINT';

export const TOGGLE_PREVIEW = 'connector-screen/TOGGLE_PREVIEW';
export const GET_PREVIEW_DATA = 'connector-screen/GET_PREVIEW_DATA';
export const CLEAR_PREVIEW_DATA = 'connector-screen/CLEAR_PREVIEW_DATA';

export const SHOW_STARTING_POINT_MODAL = 'connector-screen/SHOW_STARTING_POINT_MODAL';
export const HIDE_STARTING_POINT_MODAL = 'connector-screen/HIDE_STARTING_POINT_MODAL';
export const TOGGLE_STARTING_POINT_MODAL = 'connector-screen/TOGGLE_STARTING_POINT_MODAL';

export const TOGGLE_STARTING_POINT_DATA = 'connector-screen/TOGGLE_STARTING_POINT_DATA';
export const ADD_NEW_STARTING_POINT = 'connector-screen/ADD_NEW_STARTING_POINT';
export const UPDATE_STARTING_POINT = 'connector-screen/UPDATE_STARTING_POINT';
export const DELETE_STARTING_POINT = 'connector-screen/DELETE_STARTING_POINT';

export const SET_PITCH_BOOK_ENDPOINTS = 'connector-screen/SET_PITCH_BOOK_ENDPOINTS';
export const SET_STATIC_ENDPOINTS_DATA = 'connector-screen/SET_STATIC_ENDPOINTS_DATA';
export const CLEAR_STATIC_ENDPOINTS_DATA = 'connector-screen/CLEAR_STATIC_ENDPOINTS_DATA';
export const UPDATE_STATIC_ENDPOINT = 'connector-screen/UPDATE_STATIC_ENDPOINT';
export const DELETE_STATIC_ENDPOINT = 'connector-screen/DELETE_STATIC_ENDPOINT';
export const SET_ENDPOINT_ENTRY_COLUMNS = 'connector-screen/SET_ENDPOINT_ENTRY_COLUMNS';
export const SET_CONNECTOR_DATA = 'connector-screen/SET_CONNECTOR_DATA';
export const SET_SALESFORCE_ENDPOINT_PREVIEW = 'connector-screen/SET_SALESFORCE_ENDPOINT_PREVIEW';
export const SET_NEW_SALESFORCE_STATIC_ENDPOINTS_DATA = 'connector-screen/SET_NEW_SALESFORCE_STATIC_ENDPOINTS_DATA';
export const SET_NEW_DYNAMO_STATIC_ENDPOINTS_DATA = 'connector-screen/SET_NEW_SALESFORCE_STATIC_ENDPOINTS_DATA';
export const SET_DISABLE_DURING_REQUEST = 'connector-screen/SET_DISABLE_DURING_REQUEST';
export const GET_DYNAMO_CONNECTOR_LIST = 'connector-screen/GET_DYNAMO_CONNECTOR_LIST';
export const SET_ENDPOINT_CONFIG_MODAL_STATE = 'connector-screen/SET_ENDPOINT_CONFIG_MODAL_STATE';
export const SET_DYNAMO_ENDPOINT_CONFIG_MODAL_STATE = 'connector-screen/SET_DYNAMO_ENDPOINT_CONFIG_MODAL_STATE';
export const SET_DYNAMO_DESCRIPTION_SCHEMA_MODAL_STATE = 'connector-screen/SET_DYNAMO_DESCRIPTION_SCHEMA_MODAL_STATE';

export const SET_ENDPOINT_CONFIG = 'connector-screen/SET_ENDPOINT_CONFIG';
export const ADD_ELEMENT_TO_ENDPOINT_CONFIG = 'connector-screen/ADD_ELEMENT_TO_ENDPOINT_CONFIG';
export const REMOVE_ELEMENT_TO_ENDPOINT_CONFIG = 'connector-screen/REMOVE_ELEMENT_TO_ENDPOINT_CONFIG';

export const UPDATE_DYNAMO_ENDPOINT = 'connector-screen/UPDATE_DYNAMO_ENDPOINT';
export const UPDATE_DYNAMO_SCHEMA = 'connector-screen/UPDATE_DYNAMO_SCHEMA';
export const UPDATE_DYNAMO_ENDPOINT_CONFIG = 'connector-screen/UPDATE_DYNAMO_ENDPOINT_CONFIG';
export const SET_LOADING_STATE = 'connector-screen/SET_LOADING_STATE';
export const SET_PREVIEW = 'connector-screen/SET_PREVIEW';
export const SET_READ_ENABLED_STATE_FOR_ALL_SCHEMAS = 'connector-screen/SET_READ_ENABLED_STATE_FOR_ALL_SCHEMAS';
export const UPDATE_READ_ONLY_ENABLED_FIELDS = 'connector-screen/UPDATE_READ_ONLY_ENABLED_FIELDS';
export const SET_PREVIEW_LOADING = 'connector-screen/SET_PREVIEW_LOADING';
export const RESET_DYNAMO_STATE = 'connector-screen/RESET_DYNAMO_STATE';